export default __webpack_public_path__ + "static/media/IconPasswordConfirm.dfe0d44e.svg";